import { AsyncPipe, Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ClientSwitchInfo, ClientSwitchService, findBySearch } from '@mri-platform/shared/core';
import {
  DrawerBodyDirective,
  DrawerComponent,
  DrawerFooterDirective,
  DrawerFooterToolbarComponent
} from '@mri-platform/shared/core-ui';
import { UI_DATALIST } from '@mri-platform/ui-datalist';
import { AuthService } from '@mri/angular-wfe-proxy-oidc';
import { RxState } from '@rx-angular/state';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';

interface RouteData {
  clients: ClientSwitchInfo[];
}
type ComponentState = RouteData & {
  selectedClient?: ClientSwitchInfo;
  currentClientID?: string;
};
type PublicState = ComponentState;

// interface Projections {}

type ViewModel = PublicState; // & Projections;

const initialPublicState: PublicState = {
  clients: [],
  currentClientID: ''
};

const initialState: ComponentState = {
  ...initialPublicState,
  selectedClient: undefined
};

@Component({
  selector: 'mri-shared-client-list',
  templateUrl: './client-switch-list-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [RxState],
  imports: [
    DrawerComponent,
    UI_DATALIST,
    DrawerFooterToolbarComponent,
    DrawerFooterDirective,
    DrawerBodyDirective,
    AsyncPipe
  ],
  standalone: true
})
export class ClientSwitchListPageComponent {
  @Output() routeToParent = new EventEmitter();
  vm$: Observable<ViewModel>;

  applyFilter = findBySearch<ClientSwitchInfo>({
    searchFields: ['licenseId']
  });
  constructor(
    private route: ActivatedRoute,
    private state: RxState<ComponentState>,
    private clientSwitchService: ClientSwitchService,
    private location: Location,
    private authService: AuthService
  ) {
    // Set initial state in RxState
    this.state.set(initialState);

    // Connect any observable-driven items to state for items in ComponentState...

    const data$ = this.route.data as Observable<RouteData>;
    this.state.connect('clients', data$.pipe(pluck('clients')));
    this.state.connect('currentClientID', this.authService.currentClientId$);

    // Create projections (calculations from ComponentState)...
    // none

    // Create ViewModel (Projections + PublicState)...

    this.vm$ = this.state.select();

    // side effects if any...
    // none
  }

  closeDrawer() {
    this.location.back();
  }

  selectItem(selectedClient: ClientSwitchInfo) {
    this.state.set({ selectedClient });
  }

  switchClient() {
    const selectedClient = this.state.get('selectedClient');
    if (!selectedClient) {
      return;
    }
    const { licenseId } = selectedClient;
    this.clientSwitchService.switchClient(licenseId);
  }

  itemDisabled = (item: ClientSwitchInfo) => {
    return this.state.get('currentClientID') === item.licenseId;
  };

  sortComparer = (a: ClientSwitchInfo, b: ClientSwitchInfo) => {
    const currentId = this.state.get('currentClientID');
    if (a.licenseId === currentId) {
      return -1;
    }
    if (b.licenseId === currentId) {
      return 1;
    }
    return 0;
  };
}
